module.exports = __webpack_public_path__ + "img/gwnu_thumbnail.c0441099.jpg";